import React, {Ref, RefObject, useRef, useState} from "react"
import {connect} from "react-redux"
import {ReducerState} from "../../../../../../reducer/interface/baseInterface"
import {ComparisonStatus} from "../../../../../../reducer/interface/controlInterface"
import {CanvasDataByType, ContentItem, ImageItemData} from "../../../../../../reducer/interface/dataInterface"
import Styles from "./canvas.less"
import PageItem from "./pageItem/pageItem"

interface TDACanvasProps {
    pageItemPosition: any
    comparisonStatus: ComparisonStatus
    hoverItem: ContentItem | null
    lastHoverItem: ContentItem | null
    baseRef: RefObject<HTMLDivElement | null>
    canvasData: Array<CanvasDataByType>
    imgList: Array<ImageItemData>
    type: string
    scrollMove: (x: number, y: number) => void
}

const TDACanvas: React.FunctionComponent<TDACanvasProps> = (props) => {
    const canvasBody = useRef<HTMLDivElement>(null)
    const [startMove, setStartMove] = useState(false)
    const [startX, setX] = useState(0)
    const [startY, setY] = useState(0)
    const handleMouseDown = (e: any) => {
        setX(e.clientX)
        setY(e.clientY)
        setStartMove(true)
    }
    const handleMouseMove = (e: any) => {
        if (startMove === true) {
            setX(e.clientX)
            setY(e.clientY)
            props.scrollMove(e.clientX - startX, e.clientY - startY)
        }
    }
    const handleMouseUp = () => {
        setX(0)
        setY(0)
        setStartMove(false)
    }
    return (
        <div
            key={`${props.type}CanvasBody`}
            ref={canvasBody}
            style={{display: props.comparisonStatus.status === "success" ? "block" : "none"}}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            id={`${props.type}CanvasOutBox`}
            className={Styles.drawCanvasBox}
        >
            {props.imgList.map((item, index) => {
                return (
                    <PageItem
                        key={`${props.type}Item${index}`}
                        type={props.type}
                        baseRef={props.baseRef}
                        hasData={
                            props.pageItemPosition[props.type].find((item: any) => item.pageNum === index + 1)?.hasData
                        }
                        imgData={item}
                        index={index}
                        shapeData={props.canvasData[index]}
                    />
                )
            })}
        </div>
    )
}
export default connect((state: ReducerState) => {
    return {
        pageItemPosition: state.control.pageItemPosition,
        comparisonStatus: state.control.comparisonStatus,
        hoverItem: state.data.hoverItem,
        lastHoverItem: state.data.lastHoverItem,
    }
})(TDACanvas)
